module.exports = __webpack_public_path__ + "static/media/btn2.3ad5d697.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/btn2.png
// module id = 1356
// module chunks = 0